import http, {configForm, configJson} from "./config/http-configs";

//2.访客记录
export const getRecordList = (postData) => {
    const url = '/manage/record/list/'
    return http.post(url, postData, configJson)
}

// 门禁记录
export const getEntranceGuardRecordList = (postData) => {
    const url = '/manage/through/list'
    return http.post(url, postData, configJson)
}


export const signEnter = (applyId, visitorCode, extraInfo, areaId, enterGuardName) => {
    let url = `/manage/record/enter`
    let postData = {
        applyId: applyId,
        visitorCode: visitorCode,
        enterAreaId: areaId,

        enterCarNum: extraInfo.enterCarNum,
        enterCardNo: extraInfo.enterCardNo,
        comments: extraInfo.comments,
        enterGuardName: enterGuardName
    }

    return http.post(url, postData, configJson)
}

export const signEnterBatch = (postData) => {
    const url = `/manage/record/enter/batch`
    return http.post(url, postData, configJson)
}

export const signLeaveBatch = (postData) => {
    const url = `/manage/record/leave/v2`
    return http.post(url, postData, configJson)
}

export const getVisitorRecord = (visitorId, applyId) => {
    let url = `/manage/record/list/info/visitor?visitorId=${visitorId}&applyId=${applyId}`
    return http.post(url, null, configForm)
}

export const usualVisitorSignEnter = (data) => {
    const url = `/manage/record/enter/usual`
    return http.post(url, data, configJson)
}

export const usualVisitorSignLeave = (data) => {
    const url = `/manage/record/leave/v2`
    return http.post(url, data, configJson)
}

export const getTodayTotal = () => {
    const url = '/manage/statistic/guard/today'
    return http.get(url)
}
export const getTodayRecordTotal = (areaIds) => {
    const url = `/manage/statistic/guard/today/record?areaIds=${areaIds}`
    return http.post(url, null, configForm)
}
export const getTodayApplyTotal = (areaIds) => {
    const url = `/manage/statistic/guard/today/apply?areaIds=${areaIds}`
    return http.post(url, null, configForm)
}

// type: TODAY, WEEK, MONTH, YEAR
// areaIds: [1, 2, 3] or null is all
// year: "2020" or null
export const getHomeTotal = (type, year, areaIds, departIds) => {
    const url = '/manage/statistic/home'
    let data = {type: type, year: year, areaIds: areaIds, departIds: departIds}
    return http.post(url, data, configJson)
}

// /manage/record/list/enter/record
export const getTodayEnterRecordByVisitorCode = (visitorCode) => {
    const url = '/manage/record/list/enter/record'
    const data = {visitorCode: visitorCode}
    return http.post(url, data, configJson)
}

export const getTodayEnterRecordByPinCode = (pinCode) => {
    const url = '/manage/record/list/enter/record'
    const data = {pinCode: pinCode}
    return http.post(url, data, configJson)
}

export const getTodayEnterRecordByGateCardNo = (gateCardNo) => {
    const url = '/manage/record/list/enter/record'
    const data = {cardNo: gateCardNo}
    return http.post(url, data, configJson)
}

export const getTodayEnterRecord = (postData) => {
    const url = '/manage/record/list/enter/record'
    return http.post(url, postData, configJson)
}

// /manage/record/check/state
export const checkRecordState = (applyId, visitorCodeList, enterDate) => {
    const url = '/manage/record/check/state'
    const data = {applyId: applyId, visitorCodes: visitorCodeList, enterDate: enterDate}
    return http.post(url, data, configJson)
}
